import classNames from 'classnames';
import React from 'react';
import styles from './Grid.module.scss';
function Grid({ columns = 1, vp = 0, hp = 0, gap = 16, maxWidth = 2000, overflow, children, }) {
    const classes = classNames(styles.wrap, styles[`columns-${columns}`], {
        [styles.overflow]: overflow,
        [styles.maxWidth]: maxWidth,
    });
    return (React.createElement("div", { className: classes, style: { padding: `${vp}px ${hp}px`, gap: `${gap}px`, maxWidth: `${maxWidth}px` } }, children));
}
export default Grid;
